import { ApplicationInsights } from '@microsoft/applicationinsights-web'

export const appInsights = new ApplicationInsights({ config: {
  instrumentationKey: process.env.appInsightsInstrumentationKey
    /* ...Other Configuration Options... */
} })

appInsights.loadAppInsights()
appInsights.trackPageView()



// WEBPACK FOOTER //
// ./scripts/src/shared/applicationInsights.js